export default {
  importResult: {
    processing: 'Processing import. Please wait.',
    counts: 'Saved {{success}} rows. {{error}} rows failed.',
    success: 'Import completed successfully.',
    partial_success:
      'Saved {{success}} rows. {{error}} rows failed. Please correct and import only the failed rows.',
    failure: 'All rows failed validation. No rows were saved.',
    failed: 'Import processing failed.',
    cancel: 'Import was cancelled.',
    download: 'Download failed rows',
    downloadError: 'Download failed: {{message}}'
  },
  templateDownload: {
    label: 'Download template — {{category}}',
    unavailable: 'No template is available for this category yet.'
  },
  ioRecords: {
    view: 'View I/O',
    title: 'Current I/O records',
    company: 'Company: {{company}}',
    note: 'Current I/O data may include multiple imports and later edits. These are not the results of a specific job.',
    'filter-note':
      'Select at least one complete date range. All selected filters must match. Created and updated dates use Thailand time (UTC+7); updated means the latest change from any flow.',
    workDate: 'Work date',
    createdDate: 'Created date',
    updatedDate: 'Updated date',
    From: 'From',
    To: 'To',
    employee_code: 'Employee code',
    branch_code: 'Branch',
    date: 'Work date',
    time_in: 'Time in',
    time_out: 'Time out',
    pis_master_shift_code: 'Shift',
    input_type: 'Source',
    io_code: 'I/O code',
    createdAt: 'Created (Thailand time)',
    updatedAt: 'Updated (Thailand time)',
    'previous-day': 'Previous day',
    'next-day': 'Next day',
    search: 'Search',
    clear: 'Reset filters',
    refresh: 'Refresh',
    loading: 'Loading I/O records…',
    'load-error': 'Could not load I/O records. Please try again.',
    invalid:
      'Select at least one date range with valid start and end dates, in order.',
    empty: 'No I/O records match these filters.',
    'page-summary': 'Page {{page}} · {{total}} records',
    previous: 'Previous',
    next: 'Next',
    close: 'Close'
  },
  history: {
    title: 'Import history',
    'type-title': '{{type}} import history',
    'scoped-note':
      'Only saved history for this import type is shown. Queued jobs and failures without a history record are not included. Select Time → SFTP to view SFTP jobs.',
    company: 'Saved import history for company {{company}}',
    filter: 'Import type',
    all: 'All types',
    types: {
      time: 'Time',
      allowance: 'Special allowance',
      ot: 'OT',
      mapping: 'Card Mapping'
    },
    statuses: {
      success: 'Success',
      partial_success: 'Partial success',
      failure: 'Failed',
      cancel: 'Cancelled',
      pending: 'Pending',
      duplicate: 'Duplicate',
      invalid: 'Invalid'
    },
    refresh: 'Refresh',
    loading: 'Loading import history…',
    'load-error': 'Could not load import history. Please try again.',
    empty: 'No saved import history.',
    note: 'Only saved import history is shown. Queued jobs and failures without a history record are not included. SFTP jobs are shown separately below.',
    'time-actor': 'Time / Started by',
    'type-file': 'Type / File',
    status: 'Status',
    detail: 'Details',
    'open-detail': 'View import results for {{file}}',
    'detail-title': 'Import results',
    'page-summary': 'Page {{page}} · {{total}} records',
    previous: 'Previous',
    next: 'Next',
    unavailable:
      'Saved result details could not be read. The history record is still available.',
    'empty-result': 'No saved row results.',
    row: 'Row',
    employee: 'Employee code',
    message: 'Result details',
    close: 'Close'
  },
  ui: {
    title: 'Import data',
    description:
      'Import attendance, special allowance or OT data. Review your files before confirming.',
    'file-format': 'Select file format',
    'drop-here': 'Drop files here, or',
    browse: 'browse files',
    'selected-files': 'Selected files ({{count}})',
    'no-file': 'No file selected',
    'remove-file': 'Remove file {{name}}',
    'file-status': {
      staged: 'Not uploaded yet',
      sending: 'Sending',
      queued: 'Job queued',
      review: 'Check submission outcome'
    },
    'drop-file': 'Drop {{type}} files',
    'choose-or-drop': 'Drag files here or click to choose',
    'excel-files': '.xlsx / .csv · One file at a time',
    'sftp-files': '.txt / .csv · Up to 10 files',
    company: 'Company {{company}}',
    types: 'Import data type',
    time: 'Time',
    allowance: 'Special allowance',
    ot: 'OT',
    mapping: 'Card Mapping',
    'mapping-disabled':
      'Card Mapping import is disabled for this company. Saved history is still available below.',
    'time-title': 'Import time attendance',
    'time-description': 'Excel / CSV or SFTP clock data',
    'allowance-title': 'Import special allowance',
    'allowance-description': 'Special allowance · Excel / CSV',
    'ot-title': 'Import overtime',
    'ot-description': 'OT · Excel / CSV',
    'mapping-title': 'Employee card mapping',
    'mapping-description': 'Card mapping · Excel / CSV',
    'upload-time': 'Upload Excel / CSV',
    upload: 'Upload file',
    confirm: 'Confirm import',
    sync: 'Sync SFTP',
    'refresh-result': 'Refresh results',
    'job-status': 'Job status: {{status}}'
  },
  'sftp-claim': {
    title: 'An SFTP job holds this company’s import lock',
    job: 'Job ID',
    detail: 'View job',
    release: 'Release job lock',
    'confirm-title': 'Confirm job lock release',
    confirm: 'Release the SFTP import lock for {{company}}?',
    'saved-data': 'Saved data and job history will remain.',
    'no-retry': 'This job will not resume or retry automatically.',
    'pending-data':
      'A subsequent job may process earlier pending company data through the existing I/O flow.',
    reviewed: 'I have reviewed the outcome and saved data of this job.',
    cancel: 'Cancel',
    'confirm-release': 'Confirm release',
    refresh: 'Refresh',
    'load-error':
      'Unable to verify the company lock. Refresh before releasing it.',
    'release-error':
      'The lock was not released or the outcome could not be confirmed. Refresh and check the locking job before trying again.',
    reasons: {
      'no-claim': 'No job holds the company lock.',
      'not-reviewable': 'The job has not reached a reviewable I/O outcome.',
      'processing-error':
        'This interruption or error requires administrator review. It cannot be released with this button.',
      'queue-missing':
        'The queue record is missing. An administrator must verify that processing has stopped.',
      'queue-mismatch':
        'The queue record does not match this job. An administrator must investigate.',
      'worker-not-completed':
        'The worker has not reached the finished state required for this job. Refresh and verify the job before releasing its lock.',
      'worker-locked':
        'A worker lock is still present. Release is unavailable.',
      'queue-unavailable':
        'The worker status could not be verified. Refresh or contact an administrator.',
      'claim-changed': 'The job changed. Refresh before continuing.'
    }
  },
  'sftp-tracking': {
    'time-actor-company': 'Time / Started by',
    'status-step': 'Status / Step',
    'company-results': 'Import results for company {{company}}',
    'saved-rows': '{{rows}} rows saved',
    'shown-jobs': 'Jobs shown: {{rows}}',
    title: 'SFTP import jobs',
    note: 'Raw data saved does not mean I/O is complete. Check both before importing again.',
    refresh: 'Refresh',
    time: 'Time',
    actor: 'Started by',
    source: 'Source',
    company: 'Company',
    step: 'Step',
    status: 'Status',
    counts: {
      rawSaved: 'Raw saved',
      error: 'Errors',
      hold: 'Hold',
      pending: 'Pending',
      review: 'Rows to review'
    },
    detail: 'Details',
    empty: 'No SFTP jobs',
    older: 'Older jobs',
    latest: 'Latest jobs',
    job: 'Job ID',
    parent: 'Parent job',
    backup: 'Backup',
    'hold-only': 'Show Hold only',
    hidden:
      'Source data is shown only for the current company. Employee data for other or unidentified companies is hidden.',
    select: 'Select',
    file: 'File',
    line: 'Line',
    reason: 'Reason',
    original: 'Original line',
    redacted: 'Data hidden',
    previous: 'Previous',
    next: 'Next',
    resume: 'Import held rows',
    io: 'I/O processing status',
    'io-note':
      'Only the I/O processing status is shown. The system does not store I/O results for individual rows. I/O may include earlier pending company data.',
    close: 'Close',
    loading: 'Loading',
    'confirm-title': 'Confirm held-row import',
    confirm:
      'Import {{count}} selected rows into {{company}}? The current employee and mapping data will be checked again.',
    cancel: 'Cancel',
    queued: 'Job accepted. Follow its progress in the SFTP table.',
    'load-error': 'Unable to load results. Refresh before trying again.',
    'resume-error':
      'The outcome is unknown or the rows are already claimed. Refresh and check jobs before retrying.',
    statuses: {
      queued: 'Queued',
      processing: 'Processing',
      pending: 'Pending',
      claimed: 'Claimed',
      writing: 'Write requires review',
      'raw-saved': 'Raw saved',
      error: 'Error',
      hold: 'Hold',
      success: 'Success',
      partial: 'Partial success',
      partial_success: 'Partial success',
      'no-data': 'No data',
      'needs-review': 'Needs review',
      failed: 'Failed',
      unsupported: 'Files of 10 MiB or larger are unsupported',
      'not-run': 'Not run',
      cancel: 'I/O failed',
      failure: 'Failure',
      invalid: 'Invalid',
      duplicate: 'Duplicate'
    },
    sources: {
      sync: 'Sync SFTP',
      upload: 'Local upload',
      hold: 'Held-row import'
    },
    steps: {
      accepted: 'Accepted',
      'read-files': 'Read files',
      'parse-files': 'Parse files',
      'classify-company': 'Resolve company',
      'raw-import': 'Save raw data',
      'io-processing': 'Process I/O',
      completed: 'Finished'
    },
    backups: {
      'not-applicable': 'Not applicable / not started',
      pending: 'Move not confirmed',
      moved: 'Moved'
    },
    reasons: {
      'other-company': 'Another company',
      'invalid-row': 'Invalid row format',
      'invalid-date': 'Invalid date or time',
      'ambiguous-company': 'Company or employee is ambiguous',
      'employee-or-mapping-not-found': 'No valid employee or card mapping',
      'branch-not-found': 'Employee branch not found',
      'duplicate-or-invalid': 'Duplicate or failed existing validation',
      'worker-interrupted':
        'Worker interrupted or result incomplete. Ask an administrator to reconcile data before continuing.',
      'ot-queue-failed':
        'I/O was saved, but the OT calculation queue could not be confirmed. Check worker logs before continuing; no automatic retry.',
      'processing-stopped':
        'Processing stopped. Saved data remains; writes are not retried automatically.',
      'acceptance-failed':
        'Admission is not confirmed. Check tracking before retrying.',
      'company-busy':
        'Another company job holds the claim. Ask an administrator to review it before starting again.'
    },
    'counts-title': 'Row counts'
  },
  'sftp-upload': {
    button: 'Import SFTP files',
    title: 'Import SFTP files from your computer',
    limits:
      'TXT or CSV in UTF-8, up to 10 files. Maximum 5 MiB per file and 20 MiB in total. Use the same file format as your SFTP sync.',
    scope:
      'Uses the company open on this page and each employee’s branch. Other or unidentified companies are held.',
    choose: 'Choose files',
    sizes: 'Selected file sizes',
    submit: 'Import',
    close: 'Close',
    'new-batch': 'Choose a new batch',
    processing: 'Submitting files to create an import job. Please wait.',
    complete: 'File import and clock-in/out processing completed successfully.',
    'review-results':
      'Some steps did not complete successfully. Review the results and import history before importing again.',
    stopped:
      'Processing stopped. Previously saved data remains. Review the file results and import history before importing again.',
    rejected:
      'The upload was rejected. Check the file type, size, count and UTF-8 text content.',
    'access-error':
      'Unable to access this import. Check your permissions and the selected company setting.',
    unknown:
      'The import outcome could not be confirmed. Check import history before importing again; some data may already have been saved.',
    'io-title': 'Clock-in/out processing',
    'io-scope':
      'These results include the uploaded files and any existing unprocessed time records for the company.',
    row: 'Row',
    validation: {
      required: 'Choose at least one file.',
      count: 'Choose no more than 10 files.',
      extension: 'Only TXT and CSV files are supported.',
      size: 'Each file must contain data and be no larger than 5 MiB.',
      total: 'The total file size must not exceed 20 MiB.'
    },
    status: {
      'not-run': 'Not processed',
      success: 'Successful',
      partial: 'Contains errors',
      failed: 'Failed or incomplete',
      cancel: 'Cancelled',
      failure: 'Failed',
      pending: 'Pending',
      partial_success: 'Partially successful',
      duplicate: 'Duplicate',
      invalid: 'Invalid'
    }
  },
  form: {
    'time-att-file': 'Upload File (.csv , .xlsx)',
    'mapping-att-file': 'Upload File (.csv , .xlsx)',
    'sp-all-att-file': 'Upload File (.csv , .xlsx)',
    'ot-att-file': 'Upload File (.csv , .xlsx)',
    'time-sync-sftp': 'Manual Sync Sftp file.',
    title: {
      'map-att': 'Mapping Employee Card id Document Management',
      'time-att': 'Time Employee Document Management',
      'sp-all-att': 'Special Allowance Employee Document Management',
      'ot-att': 'OT Employee Document Management'
    },
    button: {
      'sync-sftp': 'Sync Sftp'
    }
  },
  'import-table': {
    row: 'Row',
    empCode: 'Employee Code',
    detail: 'Detail',
    status: 'Status'
  },
  modal: {
    'sync-success': 'Sync Sftp Success.',
    'sync-success-title': 'Sync Complete.'
  },
  tabs: {
    'import-file': 'Import File.',
    approve: 'Approve management'
  },
  title: 'E-Time',
  home: 'Home'
}
